<template>
    <div>
        <div class="video-ads-filters">
            <h2>Video Ads</h2>
            <div style="overflow:hidden; padding-bottom: 15px;">
                <button class="btn"
                        :class="{ 'btn-primary' : (currentAds === 'active'), 'btn-secondary' : (currentAds !== 'active') }"
                        @click="currentAds = 'active'">Active
                </button>
                <button class="btn"
                        :class="{ 'btn-primary' : (currentAds === 'deleted'), 'btn-secondary' : (currentAds !== 'deleted') }"
                        @click="currentAds = 'deleted'">Deleted
                </button>
                <button class="btn btn-primary pull-right" @click="openUploadDialog = true"><i class="fas fa-upload"></i> Upload Video
                </button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-striped table-hover" v-loading="isBusy">
                <tbody>
                <tr>
                    <th>Type</th>
                    <th>Job</th>
                    <th>Videos</th>
                    <th>Target URL</th>
                    <th>Categories</th>
                    <th>Hammer Audience</th>
                    <th></th>
                </tr>
                <tr v-if="videoAds.length === 0">
                    <td colspan="7" class="text-center">No Videos</td>
                </tr>
                <tr v-else v-for="ad in videoAds">
                    <td>
                        {{ ad.job_id == null ? 'per Employer' : 'per Job' }}
                        <span v-if="ad.isDeleted"
                              class="label label-danger"
                              title="This ad was deleted manually by users.">DELETED</span>
                        <span v-else-if="ad.isPaused"
                              class="label label-warning"
                              title="This ad was automatically paused by the system.">PAUSED</span>
                        <span v-else-if="ad.isChanged"
                              class="label label-info"
                              title="This ad is marked for recalculation. Probably there were some important changes to job or employer. Or this is freshly uploaded video.">NOT UP-TO-DATE</span>
                    </td>
                    <td>{{
                            ad.job_id == null ? '-' : ad.job_id + " - " + ad.job_title + (!ad.admin_description ? '' : ` (${ad.admin_description})`)
                        }}
                    </td>
                    <td v-html="getVideoURLs(ad.videoUrlPortrait, ad.videoUrlLandscape, ad.videoUrlSquare)"></td>
                    <td><a v-if="ad.target_url" :href="ad.target_url" target="_blank">URL</a></td>
                    <td>
                        <span v-for="tag in ad.categories" class="label"
                              :class="{ 'label-default' : (tag !== 'Owner Operators'), 'label-primary' : (tag === 'Owner Operators') }"
                              style="margin-right:5px">
                            {{ tag }}
                        </span>
                    </td>
                    <td>{{ (ad.isPaused || ad.isChanged || ad.isDeleted) ? 'N/A' : ad.driversPool }}</td>
                    <td>
                        <a v-if="ad.isDeleted"
                           href="#"
                           @click.prevent="() => deleteVideo(ad.id, false)"
                           class="text-success"
                           title="Undelete the video (will be active again)."><i class="fas fa-trash-undo" aria-hidden="true"></i></a>
                        <a v-else
                           href="#"
                           @click.prevent="() => deleteVideo(ad.id, true)"
                           class="text-danger"
                           title="Delete the video."><i class="fas fa-trash" aria-hidden="true"></i></a>

                        <a v-if="!ad.isDeleted && ad.isPaused"
                           href="#"
                           @click.prevent="() => unpauseVideo(ad.id)"
                           class="text-success"
                           title="Unpause the video (will be active again)." style="margin-left:10px;font-weight:bold;">Unpause</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <video-ad-upload-dialog :employer-id="employerId" :is-visible="openUploadDialog"
                                @close="openUploadDialog = false" @uploaded="videoUploaded"/>

        <employer-notes-wrapper :employer-id="employerId"/>
    </div>
</template>

<script>
import VideoAdUploadDialog from "./dialogs/video-ad-upload-dialog";

export default {
    components: {VideoAdUploadDialog},
    props: [
        'employerId'
    ],
    data() {
        return {
            isBusy: false,
            openUploadDialog: false,
            videoAds: [],
            currentAds: 'active'
        };
    },
    watch: {
        currentAds(newValue, oldValue) {
            if (newValue === oldValue) return;
            this.currentAds = newValue;
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.isBusy = true;
            return axios.get(url(`admin/employer/${this.employerId}/video-ads-data?status=${this.currentAds}`))
                .then(response => {
                    this.videoAds = response.data.ads;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        videoUploaded() {
            this.openUploadDialog = false;
            this.refresh();
        },
        deleteVideo(videoAdID, deleteVideo) {
            this.isBusy = true;
            return axios.post(url(`admin/employer/${this.employerId}/delete-video/${videoAdID}`), {
                'delete': (deleteVideo ? 1 : 0)
            }).then(response => {
                this.refresh();
            });
        },
        unpauseVideo(videoAdID) {
            this.isBusy = true;
            return axios.post(url(`admin/employer/${this.employerId}/unpause-video/${videoAdID}`), {
                'unpause': 1
            }).then(response => {
                this.refresh();
            });
        },
        getVideoURLs(urlPortrait, urlLandscape, urlSquare) {
            return this.getURLtag(urlPortrait, '9:16', '9:16 N/A')
                + this.getURLtag(urlLandscape, '16:9', '16:9 N/A')
                + this.getURLtag(urlSquare, '1:1', '1:1 N/A');
        },
        getURLtag(url, textYes, textNo) {
            return url === null
                ? `<span>${textNo}</span><br>`
                : `<a href="${url}" target="_blank"><i class="fas fa-play-circle"></i> ${textYes}</a><br>`;
        }
    }
}
</script>

<style scoped>

</style>